import { REDIRECT_TO_LOGIN, RESET_REDIRECT } from './constants';

/**
 * Store current url in redux to redirect to after logging in.
 */
export const redirectToLogin = (url) => ({
  type: REDIRECT_TO_LOGIN,
  url,
});
